/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Show_Menu_LabelInputs */

const en_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const fr_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le menu`)
};

const de_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü anzeigen`)
};

const it_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra menu`)
};

const ru_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать меню`)
};

const es_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menú`)
};

const zh_cn2_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示菜单`)
};

const ja_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューを表示`)
};

const hi_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनू दिखाओ`)
};

const pt_pt2_markers_show_menu_label = /** @type {(inputs: Markers_Show_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menu`)
};

/**
* | output |
* | --- |
* | "Show menu" |
*
* @param {Markers_Show_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_show_menu_label = /** @type {((inputs?: Markers_Show_Menu_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Show_Menu_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_show_menu_label(inputs)
	if (locale === "de") return de_markers_show_menu_label(inputs)
	if (locale === "it") return it_markers_show_menu_label(inputs)
	if (locale === "ru") return ru_markers_show_menu_label(inputs)
	if (locale === "es") return es_markers_show_menu_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_show_menu_label(inputs)
	if (locale === "ja") return ja_markers_show_menu_label(inputs)
	if (locale === "hi") return hi_markers_show_menu_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_show_menu_label(inputs)
	return en_markers_show_menu_label(inputs)
});